export const T = {
  en_GB: {
    conversionFailed: "Exchange rate missing — some amounts are left out",
    availableCash: "Available",
    availableCashHint: (bankCash: string) =>
      `Bank cash (${bankCash}) after this flow's trades and the other planned transfers. Moving more than this needs a deposit.`,
  },
  nb_NO: {
    conversionFailed: "Valutakurs mangler — noen beløp er utelatt",
    availableCash: "Tilgjengelig",
    availableCashHint: (bankCash: string) =>
      `Bankkontanter (${bankCash}) etter flytens handler og de andre planlagte overføringene. Å flytte mer enn dette krever et innskudd.`,
  },
} as const;
